@if (modalService.openModalData$ | async; as openModalData) {
  <app-modal
    [buttonText]="openModalData.buttonText"
    [closeAction]="openModalData.buttonAction"
    [email]="openModalData.email"
    [isModalOpen]="isModalOpen"
    [modalText]="openModalData.text"
    [phone]="openModalData.phone"
    [supportEmail]="openModalData.supportEmail || 'support@3ddigitalvenue.com'"
    [type]="openModalData.type" />
}
